<template>
  <v-row class="fs-12" no-gutters>
    <v-col cols="4" class="text-right font-weight-medium black--text">
      Khách hàng: &nbsp;
    </v-col>
    <v-col cols="8">
      {{ order.name }}
      <span v-if="order.gender">
        ({{ order.gender == 1 ? "Nam" : "Nữ" }})
      </span>
    </v-col>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      {{ order.contact_channel_name }}: &nbsp;
    </v-col>
    <v-col cols="8">
      <QrLink :value="order.contact_value" />
    </v-col>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      {{ documentName[order.identification_document_type] }}: &nbsp;
    </v-col>
    <v-col cols="8">
      <span
        :class="{
          'primary--text text-decoration-underline cursor-pointer':
            !!order.identification_document_image,
        }"
        @click="showDocumentImages"
      >
        {{ order.identification_document_number }}
      </span>
    </v-col>

    <template v-if="order.contract_image || order.base_contract_image">
      <v-col cols="4" class="text-right font-weight-medium black--text">
        Hợp đồng: &nbsp;
      </v-col>
      <v-col cols="8">
        <span
          class="primary--text text-decoration-underline cursor-pointer"
          @click="showContractImages"
        >
          Ảnh
        </span>
      </v-col>
    </template>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      Quốc tịch: &nbsp;
    </v-col>
    <v-col cols="8">{{ order.country_name }}</v-col>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      Ngày sinh: &nbsp;
    </v-col>
    <v-col cols="8">
      {{
        order.date_of_birth
          ? formatDateTime(order.date_of_birth, "DD/MM/YYYY")
          : ""
      }}
    </v-col>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      Thuê: &nbsp;
    </v-col>
    <v-col cols="8">
      {{
        order.start_time
          ? formatDateTime(order.start_time, "DD/MM/YYYY HH:mm")
          : ""
      }}
      -
      {{
        order.end_time ? formatDateTime(order.end_time, "DD/MM/YYYY HH:mm") : ""
      }}
      <span
        v-if="
          order.delivery_status == 1 && checkPermission('e_change_start_time')
        "
        class="ml-2 cursor-pointer primary--text text-decoration-underline"
        @click="showDialogChangeTime"
      >
        Đổi
      </span>
    </v-col>

    <v-col cols="4" class="text-right font-weight-medium black--text">
      Tất toán: &nbsp;
    </v-col>
    <v-col cols="8">
      {{
        order.finish_time
          ? formatDateTime(order.finish_time, "DD/MM/YYYY HH:mm")
          : ""
      }}
      -
      <span class="text-right font-weight-medium black--text">
        {{ order.account_settlement_name }}
      </span>
    </v-col>

    <template v-if="order.delivery_address">
      <v-col cols="4" class="text-right font-weight-medium black--text">
        Địa chỉ: &nbsp;
      </v-col>
      <v-col cols="8">
        <span class="purple--text" v-if="order.id_branch_delivery">
          Giao tại cửa hàng: {{ order.delivery_address }}
        </span>
        <span class="text-capitalize error--text" v-else>
          {{ order.delivery_address }}, {{ order.delivery_ward_name }},
          {{ order.delivery_county_name }}, {{ order.delivery_city_name }}
        </span>
      </v-col>
    </template>

    <template v-if="[40, 90].includes(order.status)">
      <v-col cols="4" class="text-right font-weight-medium error--text">
        {{ order.status == 40 ? "Chưa thanh toán" : "Chờ tất toán" }}: &nbsp;
      </v-col>
      <v-col cols="8">
        <v-icon
          color="success"
          class="cursor-pointer mr-3"
          @click="showDialogQr"
        >
          mdi-qrcode
        </v-icon>

        <span
          v-if="checkPermission(['e_order_paid'])"
          class="primary--text text-decoration-underline cursor-pointer"
          @click="showDialogPaid"
        >
          Đã thanh toán?
        </span>
      </v-col>
    </template>

    <v-col cols="12" v-if="isShowItem">
      <v-simple-table class="table-padding-2 table-h-36 mt-3">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th
                role="columnheader"
                class="text-center"
                style="width: 50px; min-width: 50px"
              >
                Mã
              </th>
              <th role="columnheader" class="text-center" style="width: 75px">
                Loại tài sản
              </th>
              <th role="columnheader" class="text-center">Tài sản</th>
              <th role="columnheader" class="text-center" style="width: 75px">
                Tất toán
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in order.items"
              :key="`i_${index}_${item.id}`"
              class="text-center"
            >
              <td style="width: 50px; min-width: 50px">
                {{ item.name }}
              </td>
              <td>{{ item.asset_type_name }}</td>
              <td>{{ item.asset_name }}</td>
              <td>
                <div v-if="order.id_order_settlement">
                  <div
                    :class="
                      item.settlement_indemnify_type == 0
                        ? 'success--text'
                        : 'error--text'
                    "
                  >
                    {{
                      item.settlement_indemnify_type == 2
                        ? "Hư hại"
                        : item.settlement_indemnify_type == 1
                        ? "Mất"
                        : "Đã nhận"
                    }}
                  </div>
                  <div v-if="!!item.settlement_note">
                    Ghi chú: {{ item.settlement_note }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>

    <v-col
      cols="12"
      class="mt-5"
      v-if="isShowExchange && changeItems.length > 0"
    >
      <div class="fs-18px black--text font-weight-medium mb-3">
        Lịch sử đổi trả
      </div>
      <div
        v-for="(change, key) in changeItems"
        :key="`c_${key}_${change.id}`"
        class="mb-5"
      >
        <v-row dense class="purple--text font-weight-medium text-center">
          <v-col cols="4">{{ change.branch_code }}</v-col>
          <v-col cols="4">{{ change.account_name }}</v-col>
          <v-col cols="4">{{ formatDateTime(change.created_at) }}</v-col>
        </v-row>

        <v-simple-table class="table-padding-2 table-h-36">
          <template v-slot:default>
            <thead class="v-data-table-header">
              <tr>
                <th
                  role="columnheader"
                  class="text-center"
                  style="width: 50px; min-width: 50px"
                >
                  Mã
                </th>
                <th role="columnheader" class="text-center" style="width: 75px">
                  Loại tài sản
                </th>
                <th role="columnheader" class="text-center">Tài sản</th>
                <th role="columnheader" class="text-center" style="width: 75px">
                  Phân loại
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in change.items"
                :key="`i_${index}_${item.id}`"
                class="text-center"
              >
                <td style="width: 50px; min-width: 50px">
                  {{ item.name }}
                </td>
                <td>{{ item.asset_type_name }}</td>
                <td>{{ item.asset_name }}</td>
                <td>
                  <span
                    :class="{
                      'success--text': item.exchange_type == 1,
                      'error--text': item.exchange_type == 2,
                    }"
                  >
                    {{ item.exchange_type == 1 ? "Nhận về" : "Xuất đổi" }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-col>

    <v-dialog v-model="qrDialog" max-width="360px">
      <Payment
        v-if="qrDialog && order && order.id"
        :is-detail="true"
        :info="order"
        :is-show-card-payment="isShowCardPayment"
      />
    </v-dialog>

    <v-dialog v-model="paidDialog" max-width="360px">
      <Paid
        v-if="paidDialog && order && order.id"
        :info="order"
        @onOrderChanged="onOrderChanged"
        @close="hideDialogPaid"
      />
    </v-dialog>

    <v-dialog v-model="changeTimeDialog" max-width="360px">
      <ChangeTime
        v-if="changeTimeDialog && order && order.id"
        :info="order"
        @onOrderChanged="onOrderChanged"
        @close="hideDialogChangeTime"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import { httpClient } from "@/libs/http";
import { api as viewerApi } from "v-viewer";
import { IDENTIFICATION_DOCUMENT_NAME } from "@/libs/const";

export default {
  name: "OrderDetail",
  components: {
    QrLink: () => import("@/components/common/QrLink"),
    Payment: () => import("@/components/rent/Payment"),
    Paid: () => import("@/components/rent/Paid"),
    ChangeTime: () => import("@/components/rent/ChangeTime"),
  },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    isShowItem: {
      type: Boolean,
      default: () => true,
    },
    isShowExchange: {
      type: Boolean,
      default: () => false,
    },
    isShowCardPayment: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    changeItems: [],
    documentName: { ...IDENTIFICATION_DOCUMENT_NAME },
    qrDialog: false,
    paidDialog: false,
    changeTimeDialog: false,
  }),
  mounted() {
    this.getChangeHistory();
  },
  methods: {
    async showDialogQr() {
      this.qrDialog = true;
    },
    showDialogPaid() {
      this.paidDialog = true;
    },
    hideDialogPaid() {
      this.paidDialog = false;
    },
    showDialogChangeTime() {
      this.changeTimeDialog = true;
    },
    hideDialogChangeTime() {
      this.changeTimeDialog = false;
    },
    onOrderChanged() {
      this.$emit("onOrderChanged", true);
    },
    close() {
      this.$emit("close", true);
    },

    async getChangeHistory() {
      if (!this.isShowExchange) {
        return false;
      }
      const { data } = await httpClient.post("/order/v1/get-change-history", {
        id_order: this.order.id,
      });
      this.changeItems = [...data];
    },

    showContractImages() {
      const images = this.order.contract_image
        ? this.order.contract_image.split(";")
        : this.order.base_contract_image.split(";");
      const imageUrls = images.map(
        (img) => `${process.env.VUE_APP_FILE_CDN_URL}/${img}`
      );
      const index = 0;
      viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: index,
        },
        images: imageUrls,
      });
    },
    showDocumentImages() {
      if (!this.order.identification_document_image) {
        return false;
      }
      const images = this.order.identification_document_image.split(";");
      const imageUrls = images.map(
        (img) => `${process.env.VUE_APP_FILE_CDN_URL}/${img}`
      );
      const index = 0;
      viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: index,
        },
        images: imageUrls,
      });
    },
  },
};
</script>
